import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const SSOAuthRedirect: FC = () => {

    const [params] = useSearchParams();

    const checkToken = async () => {
        const token = params.get('token');
        if (token) {
            // standalone call 
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}api/v1/me`, {
                    headers: {
                        Authorization: 'jwt ' + token //the token is a variable which holds the token
                    }
                });
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(res.data.user));

                if(res.data.user?.accounts && res.data.user?.accounts[0]) {
                    localStorage.setItem('selectedAccount', JSON.stringify(res.data.user?.accounts[0]));
                }

                window.location.href = window.location.origin;
            } catch (e) {
                //console.log(e);
            }
        }
    }

    useEffect(() => {
        checkToken();
    }, [params, checkToken]);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <CircularProgress />
            Redirecting ...
        </Box>
    );
}

export default SSOAuthRedirect;